"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NotificationLayout", {
    enumerable: true,
    get: function() {
        return NotificationLayout;
    }
});
var NotificationLayout;
(function(NotificationLayout) {
    NotificationLayout["SIMPLE"] = "simple";
    NotificationLayout["CONDENSED"] = "condensed";
    NotificationLayout["ACTIONS_BELOW"] = "actions_below";
})(NotificationLayout || (NotificationLayout = {}));

//# sourceMappingURL=types.js.map